/*
 * Page-load cascade (original page-finish action list a-71).
 *
 * Sequenced blocks (sub-heading, buttons, hero media, the navbar, lower
 * sections) start hidden (opacity 0, nudged down 10px) and rise into place on
 * load. Delays mirror the original exactly: load-1 0.6s, load-2 0.8s, load-3
 * 1.0s, navbar 1.0s, load-4 / bottom 1.2s. Duration 1s, default ease.
 *
 * No clearProps: the final inline state is left in place so elements stay
 * visible instead of falling back to the initial-hidden base rules.
 */
import type { gsap as GSAP } from 'gsap'

import { gsap, EASE } from './core'

const LOAD_DELAY: Record<string, number> = {
    'animation-on-page-load-1': 0.6,
    'animation-on-page-load-2': 0.8,
    'animation-on-page-load-3': 1.0,
    'animation-on-page-load-4': 1.2,
    'animation-bottom-on-page-load': 1.2
}

export const initPageLoad = (ctx: GSAP.Context, scope: HTMLElement): void => {
    ctx.add(() => {
        // Navbar fades in (a-71 targets .navbar at delay 1.0s).
        const navbar = scope.querySelector<HTMLElement>('.navbar')
        if (navbar) {
            gsap.fromTo(
                navbar,
                { opacity: 0 },
                { opacity: 1, duration: 1, delay: 1.0, ease: EASE }
            )
        }

        Object.entries(LOAD_DELAY).forEach(([cls, delay]) => {
            const els = gsap.utils.toArray<HTMLElement>(scope.querySelectorAll(`.${cls}`))
            els.forEach((el) => {
                gsap.fromTo(
                    el,
                    { opacity: 0, y: 10 },
                    { opacity: 1, y: 0, duration: 1, delay, ease: EASE }
                )
            })
        })
    })
}
